import { WHATS_NEW_IDS } from '@/data/whatsNew'

const SEEN_KEY = 'dashamajig_whats_new_seen'
const INTRO_KEY = 'dashamajig_whats_new_intro_seen'

function readJson(key, fallback) {
  try {
    const raw = localStorage.getItem(key)
    if (!raw) return fallback
    return JSON.parse(raw)
  } catch {
    return fallback
  }
}

export function hasSeenIntro() {
  return localStorage.getItem(INTRO_KEY) === '1'
}

export function markIntroSeen() {
  localStorage.setItem(INTRO_KEY, '1')
}

export function getSeenFeatureIds() {
  const ids = readJson(SEEN_KEY, [])
  return Array.isArray(ids) ? ids.map(String) : []
}

export function getUnseenFeatureIds() {
  const seen = new Set(getSeenFeatureIds())
  return WHATS_NEW_IDS.filter((id) => !seen.has(id))
}

export function hasUnseenFeatures() {
  return getUnseenFeatureIds().length > 0
}

/** Mark every currently shipped feature as seen. */
export function markAllFeaturesSeen() {
  const merged = Array.from(new Set([...getSeenFeatureIds(), ...WHATS_NEW_IDS]))
  localStorage.setItem(SEEN_KEY, JSON.stringify(merged))
}
